import { Route, Switch } from 'wouter';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { ForSchools } from './pages/ForSchools';
import { Catalogue } from './pages/Catalogue';
import { Contact } from './pages/Contact';
import { Quote } from './pages/Quote';
import { Partners } from './pages/Partners';
import { NotFound } from './pages/NotFound';
import { localBusinessJsonLd } from './lib/seo';

/**
 * Public application shell.
 *
 * SEVEN public routes now — the six that exactly matched production, plus
 * /partners. /products, /cleaning-supplies-for-schools and /compliance still do
 * NOT exist in production and are still not added (visual baseline N-8,
 * GATE1-D4) — that constraint is about not inventing pages production never
 * had. /partners is different: it is a genuinely NEW page for the affiliate
 * programme launch (MS-V2-AFF-001), not baseline drift, so it is the one
 * deliberate addition to the route count.
 *
 * NO ADMIN ROUTES. Rule 4: the admin is a separate application on its own host.
 * Production shipped all 15 admin routes inside this same bundle, which is why
 * every byte of admin UI was publicly downloadable (ISS-016). The affiliate
 * PORTAL (dashboards, referral tracking, payouts) follows the same rule — it is
 * a separate application on its own host, linked from the navbar's
 * Login/Register button (see lib/partnerPortal.ts), not a route in here.
 * /partners itself is just the public application form; it is not the portal.
 */

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {/* A-7: LocalBusiness structured data. Production had none at all. */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessJsonLd()) }}
      />
      <a href="#main" className="skip-link">Skip to content</a>
      <Navbar />
      <main id="main">
        <Switch>
          <Route path="/" component={Home} />
          <Route path="/about" component={About} />
          <Route path="/for-schools" component={ForSchools} />
          <Route path="/catalogue" component={Catalogue} />
          <Route path="/contact" component={Contact} />
          <Route path="/partners" component={Partners} />
          <Route path="/quote" component={Quote} />
          <Route component={NotFound} />
        </Switch>
      </main>
      <Footer />
    </QueryClientProvider>
  );
}
